import { useSearchParams } from 'react-router-dom';
import { DS_API_REQUESTOR, VPMerchantClientProvider } from '@99designs/design-services-common';
import {
    BriefProvider,
    BriefQuery,
    FieldGroupVariant,
    fieldGroups,
    useBriefQuery,
} from '@99designs/feature-design-services-brief';
import { useCollaborationContext } from '../../context';
import { ErrorLoadingState } from '../../ui';

export function useTenant() {
    const [searchParams] = useSearchParams();
    return searchParams.get('tenant') ?? process.env.VITE_COLLABORATE_VP_MERCHANT_TENANT ?? 'dev';
}

export type BriefLayoutData = {
    groups: ReturnType<typeof fieldGroups>;
    data: BriefQuery;
    collaborationId: string;
};

export const BriefLayout = ({
    children,
}: {
    children: (data: BriefLayoutData) => JSX.Element | undefined;
}) => {
    const tenant = useTenant();
    const { collaborationId, briefId } = useCollaborationContext();
    const { data, loading, error } = useBriefQuery({
        variables: {
            id: briefId,
        },
    });

    return (
        <ErrorLoadingState loading={loading} errors={error} data={data}>
            {(data) => {
                const groups = fieldGroups(data.brief, FieldGroupVariant.READONLY);

                return (
                    <VPMerchantClientProvider tenant={tenant} requestor={DS_API_REQUESTOR}>
                        <BriefProvider>
                            {children({
                                groups,
                                data,
                                collaborationId,
                            })}
                        </BriefProvider>
                    </VPMerchantClientProvider>
                );
            }}
        </ErrorLoadingState>
    );
};
